export default {
  WEIGHT_UPPER_LIMIT: 317.515,
  WEIGHT_LOWER_LIMIT: 19.0509,
  HEIGHT_UPPER_LIMIT: 236.22,
  HEIGHT_LOWER_LIMIT: 100,
};
